import theme from "@/styles/theme";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Grid, IconButton, SvgIcon } from "@mui/material";

export default function PaginationNavigation({ onPrevPage, onNextPage }) {
  const handlePrevClick = () => {
    if (onPrevPage && typeof onPrevPage === "function") {
      onPrevPage();
    }
  };

  const handleNextClick = () => {
    if (onNextPage && typeof onNextPage === "function") {
      onNextPage();
    }
  };

  return (
    <Grid container spacing={1} sx={iconButtonStyles}>
      <Grid item xs={6} sm="auto">
        <IconButton
          color="primary"
          aria-label="previous"
          onClick={handlePrevClick}
        >
          <SvgIcon
            color="secondary"
            sx={{
              fontSize: 32,
              color: theme.palette.secondary.main,
            }}
          >
            <ChevronLeftIcon />
          </SvgIcon>
        </IconButton>
      </Grid>
      <Grid item xs={6} sm="auto">
        <IconButton color="primary" aria-label="next" onClick={handleNextClick}>
          <SvgIcon
            color="secondary"
            sx={{
              fontSize: 32,
              color: theme.palette.secondary.main,
            }}
          >
            <ChevronRightIcon />
          </SvgIcon>
        </IconButton>
      </Grid>
    </Grid>
  );
}

const iconButtonStyles = {
  justifyContent: "flex-end",
  marginTop: "0.25rem",
  "& .MuiIconButton-root": {
    width: "100%",
    height: "2.5rem",
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: 0,
    [theme.breakpoints.up("sm")]: {
      width: "2.5rem",
      height: "2.5rem",
    },
    "& .MuiSvgIcon-root": {
      transition: "color 0.3s ease-in-out",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      "& .MuiSvgIcon-root": {
        color: theme.palette.common.white,
      },
    },
  },
};
